import accountConstants from '../actiontypes/account';
import { listAccounts, validateCV } from '../../api/AccountService';

function getAccounts(type, showLoading = true) {
  return dispatch => {
    const beforeAction = showLoading ? accountConstants.LIST_ACCOUNTS_REQUEST  : accountConstants.UPDATE_ACCOUNTS_REQUEST;
    const successAction = showLoading ? accountConstants.LIST_ACCOUNTS_SUCCESS  : accountConstants.UPDATE_ACCOUNTS_SUCCESS;
    const errorAction = showLoading ? accountConstants.LIST_ACCOUNTS_FAILURE  : accountConstants.UPDATE_ACCOUNTS_FAILURE;
    
    dispatch({ type: beforeAction });

    listAccounts().then(
      response => {
        let payload = response.data;

        if (type) {
          const filter =
            type === 'SIGHT' ? 'CUENTA VISTA' : 'CUENTAS DE AHORRO';

          payload = response.data.filter(a => {
            return a.familiaProducto === filter;
          });
        }

        dispatch({
          type: successAction,
          payload
        });
      },
      () => {
        dispatch({
          type: errorAction
        });
      }
    );
  };
}

function validate(){
  return dispatch => {
    dispatch({ type: accountConstants.VALIDATE_ACCOUNT_REQUEST });

    validateCV().then(
      response => {
        const payload = response.data;

        dispatch({
          type: accountConstants.VALIDATE_ACCOUNT_SUCCESS,
          payload
        });
      },
      () => {
        dispatch({
          type: accountConstants.VALIDATE_ACCOUNT_FAILURE
        });
      }
    );
  };
}

const accountActions = {
  getAccounts,
  validate
};

export default accountActions;
